"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = require("../../../../constants");
var hooks_1 = require("../../../../hooks");
var Button_1 = __importDefault(require("../../../Button/Button"));
var fields_1 = require("../../../Form/fields");
var SelectTypZaniku_1 = __importDefault(require("../../../Form/fields/SelectTypZaniku"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var Padder_1 = require("../../../Padder");
var DeleteComps_1 = require("../DeleteComps");
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var StyledDeleteDialogText = styled_components_1.default(DeleteComps_1.DeleteDialogText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > span {\n    margin-left: 5px;\n  }\n  & > span:not(:last-child)::after {\n    content: ',';\n  }\n"], ["\n  & > span {\n    margin-left: 5px;\n  }\n  & > span:not(:last-child)::after {\n    content: ',';\n  }\n"])));
var validation = function (values) {
    var datumLens = ramda_1.lensProp('od');
    var typLens = ramda_1.lensProp('idTypZanik');
    var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(datumLens, values); }, ramda_1.set(datumLens, 'Datum od je povinné')), ramda_1.when(function () { return !ramda_1.view(typLens, values); }, ramda_1.set(typLens, 'Důvod je povinný')))({});
    return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
};
var ZanikOpravneniForm = function (_a) {
    var onSubmit = _a.onSubmit, initialValues = _a.initialValues, headerText = _a.headerText, onZrusit = _a.onZrusit, disabled = _a.disabled, clenstvi = _a.clenstvi;
    var initialOd;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.od) {
        initialOd = new Date(initialValues.od.toString());
    }
    var minDate;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.minDate) {
        minDate = new Date(initialValues.minDate.toString());
    }
    var maxDate;
    if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.maxDate) {
        maxDate = new Date(initialValues.maxDate.toString());
    }
    var isWarningDialog = hooks_1.useBoolean(false);
    var isSubmit = hooks_1.useBoolean(false);
    var _b = react_1.useState(), values = _b[0], setValues = _b[1];
    var _c = react_1.useState(), formikHelpers = _c[0], setFormikHelpers = _c[1];
    var getWarningText = function (cl) {
        var korporace = [];
        var korpNedostatecnyPocetClenu = [];
        var zanikKorporaceSCleny = false;
        cl.forEach(function (c) {
            var _a, _b;
            if (c.druhOsoby === constants_1.ZnalciDruhOsoby.znaleckaKancelar) {
                korporace.push("znaleck\u00E9 kancel\u00E1\u0159e " + c.nazev);
                if (c.clenstvi.length - 1 < 2) {
                    korpNedostatecnyPocetClenu.push("znaleck\u00E1 kancel\u00E1\u0159 " + c.nazev);
                }
            }
            if (c.druhOsoby === constants_1.ZnalciDruhOsoby.znaleckyUstav) {
                korporace.push("znaleck\u00E9ho \u00FAstavu " + c.nazev);
                if (c.clenstvi.length - 1 < 1 && (((_a = c.externiSubjekt) === null || _a === void 0 ? void 0 : _a.length) === undefined || ((_b = c.externiSubjekt) === null || _b === void 0 ? void 0 : _b.length) === 0)) {
                    korpNedostatecnyPocetClenu.push("znaleck\u00FD \u00FAstav " + c.nazev);
                }
            }
            if (c.druhOsoby === constants_1.ZnalciDruhOsoby.znalec) {
                zanikKorporaceSCleny = true;
            }
        });
        var hlaska = 'Snažíte se uložit zánik oprávnění';
        if (korporace.length > 0)
            hlaska += ' znalce, který je členem';
        if (zanikKorporaceSCleny)
            hlaska += ' znalecké korporace, v níž jsou aktivní členové';
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledDeleteDialogText, null,
                hlaska,
                korporace.length > 0 && korporace.map(function (k) { return react_1.default.createElement("span", null, k); }),
                "."),
            korpNedostatecnyPocetClenu.length > 0 && (react_1.default.createElement(StyledDeleteDialogText, null,
                "Z\u00E1pisem z\u00E1niku vznikne, dle z\u00E1konn\u00E9 podm\u00EDnky, nedostate\u010Dn\u00FD po\u010Det \u010Dlen\u016F u n\u00E1sleduj\u00EDc\u00EDch korporac\u00ED:",
                korpNedostatecnyPocetClenu.map(function (k) { return (react_1.default.createElement("span", null, k)); }),
                "."))));
    };
    var getInfoHlaska = function () { return (react_1.default.createElement(DeleteComps_1.DeleteDialog, null,
        clenstvi && getWarningText(clenstvi),
        react_1.default.createElement(DeleteComps_1.DeleteDialogText, null, "Opravdu si p\u0159ejete z\u00E1nik opr\u00E1vn\u011Bn\u00ED ulo\u017Eit?"),
        react_1.default.createElement(DeleteComps_1.DeleteButtonsWrap, null,
            react_1.default.createElement(Button_1.default, { type: "button", primary: false, onClick: function () {
                    onZrusit();
                    isWarningDialog.setFalse();
                }, name: "Ne" }, "NE, ZRU\u0160IT"),
            react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: function () { return isSubmit.setTrue(); }, name: "Ano" }, "ANO, ULO\u017DIT")))); };
    var onSubmitHandle = function (val, helpers) {
        setValues(val);
        setFormikHelpers(helpers);
        if ((clenstvi === null || clenstvi === void 0 ? void 0 : clenstvi.length) && (clenstvi === null || clenstvi === void 0 ? void 0 : clenstvi.length) > 0) {
            isWarningDialog.setTrue();
        }
        else {
            onSubmit(val, helpers);
        }
    };
    react_1.useEffect(function () {
        if (isSubmit.value && values && formikHelpers) {
            formikHelpers.submitForm();
            onSubmit(values, formikHelpers);
            isWarningDialog.setFalse();
        }
    }, [isSubmit.value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { paddingLeft: '2rem', paddingTop: '2rem' } },
            react_1.default.createElement(PopupHeader_1.default, { style: { marginBottom: '0' } }, headerText)),
        react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmitHandle }, function (_a) {
            var isSubmitting = _a.isSubmitting;
            return (!disabled || isSubmitting) && (react_1.default.createElement(Padder_1.Padder, null, !isWarningDialog.value || isSubmit.value ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(fields_1.DateField, { defaultValue: initialOd, minDate: minDate, maxDate: maxDate, name: "od", label: "Datum od", toolTip: "Vyberte datum z\u00E1niku opr\u00E1vn\u011Bn\u00ED" }),
                react_1.default.createElement(SelectTypZaniku_1.default, { label: "D\u016Fvod", name: "idTypZanik", inputId: "selectTypZaniku" }),
                react_1.default.createElement(ModalButtonsWrap_1.default, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit" }, "Zru\u0161it"),
                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ulozit" }, "Ulo\u017Eit")))) : (getInfoHlaska())));
        })));
};
ZanikOpravneniForm.defaultProps = {
    initialValues: undefined,
    disabled: false,
    clenstvi: undefined,
};
exports.default = ZanikOpravneniForm;
var templateObject_1;
